var $56f3d9ca2967952d$exports = {};
$56f3d9ca2967952d$exports = {
  "backButton": args => `\u{8FD4}\u{56DE} ${args.prevMenuButton}`,
  "moreActions": `\u{66F4}\u{591A}\u{52D5}\u{4F5C}`,
  "unavailable": `\u{7121}\u{6CD5}\u{4F7F}\u{7528}\u{FF0C}\u{5C55}\u{958B}\u{4EE5}\u{53D6}\u{5F97}\u{8A73}\u{7D30}\u{8CC7}\u{6599}`
};
export { $56f3d9ca2967952d$exports as default };